import React from 'react';
import './VideoSection.css';

const VideoSection = () => {
  const handlePlayClick = (videoId) => {
    // Open YouTube video in new tab
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  };

  return (
    <section className="new-videos">
      <div className="container">
        <div className="section-header">
          <h2>Featured Videos</h2>
          {/* <p>Check the most recent news.</p> */}
        </div>
        <div className="video-grid">
          <div className="video-card video-card-left">
            <div className="video-thumbnail">
              <img src="https://img.youtube.com/vi/UZNueubzHXo/maxresdefault.jpg" alt="Fiona - Dark in the Dawn" />
              <div className="play-button" onClick={() => handlePlayClick('UZNueubzHXo')}>
                <i className="fas fa-play"></i>
              </div>
            </div>
            <div className="video-info">
              <h3>DJ SODA</h3>
              <p>DJ SODA X DJ KOREA CONNECT</p>
            </div>
          </div>
          <div className="video-card video-card-center">
            <div className="video-thumbnail">
              <img src="https://img.youtube.com/vi/lsduGj42ZJA/maxresdefault.jpg" alt="Live Performance - New Track" />
              <div className="play-button" onClick={() => handlePlayClick('lsduGj42ZJA')}>
                <i className="fas fa-play"></i>
              </div>
            </div>
            <div className="video-info">
              <h3>YOUNA</h3>
              <p>Melodic Techno & Progressive House<br />DJ Mix 13 @ Red Sand Desert I Dubai</p>
            </div>
          </div>
          <div className="video-card video-card-right">
            <div className="video-thumbnail">
              <img src="https://img.youtube.com/vi/qRHwJbBK0RY/maxresdefault.jpg" alt="Studio Session - Dark in the Dawn" />
              <div className="play-button" onClick={() => handlePlayClick('qRHwJbBK0RY')}>
                <i className="fas fa-play"></i>
              </div>
            </div>
            <div className="video-info">
              <h3>IDIOTAPE</h3>
              <p>Live at Festival MED 2024<br />(Loulé, Portugal)</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection; 